<template>
    <div>
        <div class="back" v-if="isVisible" @click="hideModal"></div>
        <div class="modalView" v-if="isVisible">
            <!-- 步骤 -->
            <div class="stepView">
                <ul class="steps flex">
                    <template v-for="(item, index) in stepList">
                        <li
                            class="step flexStyle flex-column"
                            :key="item.name"
                        >
                            <div class="flex stepTitle" @click="changeType(index)">
                                <span>0{{ item.value }}</span>
                            </div>
                            <i
                                v-if="index === stepIndex && index!== stepList.length - 1"
                                class="icon el-icon-loading"
                            ></i>
                            <div v-else-if="index < stepIndex || stepIndex == stepList.length - 1 " class="circle">
                                <i class="icon el-icon-success"></i>
                            </div>
                            <i v-else class="iconBorder"></i>
                        </li>

                        <!-- 1.进行中虚线 -->
                        <li
                            class="borderLeft activeBorder"
                            v-if="index === stepIndex && index !== stepList.length - 1"
                            :key="index"
                        >
                            <span class="borderLeftText">{{ item.name }}</span>
                            <p class="activeBorderP"></p>
                        </li>

                        <!-- 2.完成实线 -->
                        <li
                            v-else-if="index <= stepList.length"
                            class="borderLeft"
                            :key="index"
                        >
                            <span class="borderLeftText">{{ item.name }}</span>
                            <p
                                v-if="index !== stepList.length - 1"
                                class="borderLeftP"
                                :class="index < stepIndex ? 'finishBorder' : 'unFinishBorder'">
                            </p>
                            <p v-else class="borderLeftPFinish"></p>
                        </li>
                    </template>
                </ul>
            </div>
            <!-- 步骤1 定制套餐-->
            <div class="modalView_pop" v-if="stepIndex == 0">
                <div class="modalView_pop_l">
                    <img class="modalView_pop_l_polygon_1" src="@/assets/images/polygon_1.png"/>
                    <img class="modalView_pop_l_polygon_2" src="@/assets/images/polygon_2.png"/>
                    <div class="modalView_pop_l_view">
                        <div class="modalView_pop_l_view_t">
                            <div class="modalView_pop_l_view_t_1">
                                <!-- <div class="modalView_pop_l_view_t_3_text">碳盘查Agent</div> -->
                                <img v-if="featureName == 'tpc'" class="modalView_pop_l_view_t_3_img" src="@/assets/images/modalView_pop_l_view_t_1_img.png" alt="">
                                <img v-else-if="featureName == 'tzj'" class="modalView_pop_l_view_t_3_img" src="@/assets/images/modalView_pop_l_view_t_2_img.png" alt="">
                            </div>
                            <div class="modalView_pop_l_view_t_2"> —— {{ $t('ChooseProduct.disruptiveService') }}</div>
                        </div>
                        <div class="modalView_pop_l_view_b">
                            <div class="modalView_pop_l_view_b_2">
                                <div class="modalView_pop_b_l_v_d_title">{{ $t('ChooseProduct.disruptiveServiceDesc') }}</div>
                                <div class="modalView_pop_b_l_v_d_buy" v-if="featureName == 'tpc'">
                                    <div class="modalView_pop_b_l_v_d_buy_view">
                                        <div class="modalView_pop_b_l_v_d_buy_view_title">{{ $t('ChooseProduct.scopeOne') }}<span> {{ $t('ChooseProduct.scope') }}</span> {{ $t('ChooseProduct.scopeTwo') }}？</div>
                                        <div class="modalView_pop_b_l_v_d_buy_view_content">
                                            <div class="modalView_pop_b_l_v_d_buy_view_content_choose" :class="{ activeF: payInfo.scope === 0 }" @click="chooseF(0)">{{ $t('ChooseProduct.scope_list[0].name') }}</div>
                                            <div class="modalView_pop_b_l_v_d_buy_view_content_choose" :class="{ activeF: payInfo.scope === 1 }" @click="chooseF(1)">{{ $t('ChooseProduct.scope_list[1].name') }}</div>
                                        </div>
                                    </div>
                                    <div class="modalView_pop_b_l_v_d_buy_view">
                                        <div class="modalView_pop_b_l_v_d_buy_view_title">{{ $t('ChooseProduct.address_limitOne') }}<span> {{ $t('ChooseProduct.address_limit') }}</span> {{ $t('ChooseProduct.jc') }}？</div>
                                        <div class="modalView_pop_b_l_v_d_buy_view_content" @click="focusInput">
                                            <input
                                                onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                                class="inputView"
                                                :class="{ inputViewFocus: payInfo.address_limit !== '' }"
                                                v-model="payInfo.address_limit"
                                                @input="chooseC"
                                            />
                                        </div>
                                    </div>
                                    <div class="modalView_pop_b_l_v_d_buy_view">
                                        <div class="modalView_pop_b_l_v_d_buy_view_title">{{ $t('ChooseProduct.source_limitOne') }}<span> {{ $t('ChooseProduct.source_limit') }}</span> {{ $t('ChooseProduct.jc') }}？</div>
                                        <div class="modalView_pop_b_l_v_d_buy_view_content">
                                            <div class="modalView_pop_b_l_v_d_buy_view_content_choose" :class="{ activeF: payInfo.source_limit === 0 }" @click="chooseE(0)">≤100</div>
                                            <div class="modalView_pop_b_l_v_d_buy_view_content_choose" :class="{ activeF: payInfo.source_limit === 1 }" @click="chooseE(1)">101-500</div>
                                            <div class="modalView_pop_b_l_v_d_buy_view_content_choose" :class="{ activeF: payInfo.source_limit === 2 }" @click="chooseE(2)">＞500</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modalView_pop_b_l_v_d_buy" v-else-if="featureName == 'tzj'">
                                    <div class="modalView_pop_b_l_v_d_buy_view">
                                        <div class="modalView_pop_b_l_v_d_buy_view_title">您产品的<span>原辅材料数量</span>是?</div>
                                        <div class="modalView_pop_b_l_v_d_buy_view_content">
                                            <!-- <input
                                                onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                                class="modalView_pop_b_l_v_d_buy_view_content_choose inputView"
                                                :class="{ inputViewFocus: payInfo.source_limit !== '' }"
                                                v-model="payInfo.source_limit"
                                                @input="chooseUseLimit"
                                            /> -->
                                            <div class="modalView_pop_b_l_v_d_buy_view_content_choose" :class="{ activeF: payInfo.source_limit === 0 }" @click="chooseSl(0)">≤20</div>
                                            <div class="modalView_pop_b_l_v_d_buy_view_content_choose" :class="{ activeF: payInfo.source_limit === 1 }" @click="chooseSl(1)">＞20</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modalView_pop_r">
                    <div class="modalView_pop_r_2">
                        <div class="modalView_pop_r_2_title">{{ $t('ChooseProduct.choose') }}:</div>
                        <template v-if="featureName == 'tpc'">
                            <div class="modalView_pop_b_r_v_1">
                                <span>{{ $t('ChooseProduct.scope') }}：</span>
                                <span>{{ payInfo?.scope === 0 ? $t('ChooseProduct.scope_list[0].name') : payInfo?.scope === 1 ? $t('ChooseProduct.scope_list[1].name') : '' }}</span>
                            </div>
                            <div class="modalView_pop_b_r_v_1">
                                <span>{{ $t('ChooseProduct.address_limit') }}：</span>
                                <span>{{ payInfo.address_limit? payInfo.address_limit : '' }}</span>
                            </div>
                            <div class="modalView_pop_b_r_v_1">
                                <span>{{ $t('ChooseProduct.source_limit') }}：</span>
                                <span>{{ payInfo?.source_limit === 0 ? "≤100" : payInfo?.source_limit === 1 ? "101-500" : payInfo?.source_limit == 2 ? "＞500" :'' }}</span>
                            </div>
                        </template>
                        <template v-else-if="featureName == 'tzj'">
                            <div class="modalView_pop_b_r_v_1">
                                <span>核算边界：</span>
                                <span>从摇篮到大门</span>
                            </div>
                            <div class="modalView_pop_b_r_v_1">
                                <span>产品数量：</span>
                                <span>1</span>
                            </div>
                            <div class="modalView_pop_b_r_v_1">
                                <span>{{ featureName == 'tzj' ? $t('ChooseProduct.zjsource_limit') : $t('ChooseProduct.source_limit')}}：</span>
                                <span>{{ payInfo?.source_limit === 0 ? "≤20" : payInfo?.source_limit === 1 ? "＞20" :'' }}</span>
                            </div>
                        </template>
                        <div class="modalView_pop_b_r_v_3">
                            <span>{{ $t('ChooseProduct.payMent') }}:</span>
                            <span class="modalView_pop_b_r_v_3_t">{{ payInfo.total ? '￥' + payInfo.total : '' }}</span>
                        </div>
                        <div class="pay" :class="{ activePay: isPay == true }">
                            <div class="pay_inner" @click="confirm">{{ $t('ChooseProduct.confirm') }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 步骤2 确认订单-->
            <div class="modalView_pop" v-else-if="stepIndex == 1">
                <div class="modalView_pop_l">
                    <img class="modalView_pop_l_polygon_1" src="@/assets/images/polygon_1.png"/>
                    <img class="modalView_pop_l_polygon_2" src="@/assets/images/polygon_2.png"/>
                    <div class="modalView_pop_l_view">
                        <div class="modalView_pop_l_view_t">
                            <div class="modalView_pop_l_view_t_1">
                                <!-- <div class="modalView_pop_l_view_t_3_text">碳盘查Agent</div> -->
                                <img v-if="featureName == 'tpc'" class="modalView_pop_l_view_t_3_img" src="@/assets/images/modalView_pop_l_view_t_1_img.png" alt="">
                                <img v-else-if="featureName == 'tzj'" class="modalView_pop_l_view_t_3_img" src="@/assets/images/modalView_pop_l_view_t_2_img.png" alt="">
                            </div>
                            <div class="modalView_pop_l_view_t_2"> —— {{ $t('ChooseProduct.disruptiveService') }}</div>
                        </div>
                        <div class="modalView_pop_l_view_b">
                            <div class="modalView_pop_l_view_b_2">
                                <div class="modalView_pop_b_l_v_d_buy" ref="htContent">
                                    <!-- <div
                                        class="modalView_pop_b_l_v_d_buy_btn"
                                        v-if="isDown"
                                    >
                                        下载合同
                                    </div> -->
                                    <div class="iframeView">
                                        <iframe frameborder="0" :src="htUrl" class="iframeViewContent"></iframe>
                                    </div>
                                    <!-- <pdf :src="htUrl" :fit="100"></pdf> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modalView_pop_r">
                    <div class="modalView_pop_r_2">
                        <div class="modalView_pop_r_2_title">{{ $t('ChooseProduct.choose') }}:</div>
                        <template v-if="featureName == 'tpc'">
                            <div class="modalView_pop_b_r_v_1">
                                <span>{{ $t('ChooseProduct.scope') }}：</span>
                                <span>{{ payInfo?.scope === 0 ? $t('ChooseProduct.scope_list[0].name') : payInfo?.scope === 1 ? $t('ChooseProduct.scope_list[1].name') : '' }}</span>
                            </div>
                            <div class="modalView_pop_b_r_v_1">
                                <span>{{ $t('ChooseProduct.address_limit') }}：</span>
                                <span>{{ payInfo.address_limit? payInfo.address_limit : '' }}</span>
                            </div>
                            <div class="modalView_pop_b_r_v_1">
                                <span>{{ $t('ChooseProduct.source_limit') }}：</span>
                                <span>{{ payInfo?.source_limit === 0 ? "≤100" : payInfo?.source_limit === 1 ? "101-500" : payInfo?.source_limit == 2 ? "＞500" :'' }}</span>
                            </div>
                        </template>
                        <template v-else-if="featureName == 'tzj'">
                            <div class="modalView_pop_b_r_v_1">
                                <span>核算边界：</span>
                                <span>从摇篮到大门</span>
                            </div>
                            <div class="modalView_pop_b_r_v_1">
                                <span>产品数量：</span>
                                <span>1</span>
                            </div>
                            <div class="modalView_pop_b_r_v_1">
                                <span>{{ featureName == 'tzj' ? $t('ChooseProduct.zjsource_limit') : $t('ChooseProduct.source_limit')}}：</span>
                                <span>{{ payInfo?.source_limit === 0 ? "≤20" : payInfo?.source_limit === 1 ? "＞20" :'' }}</span>
                            </div>
                        </template>
                        <div class="pay activePay">
                            <!-- <el-button :disabled="comfirLoading" class="pay_inner" @click="comfirOrder">{{ $t('ChooseProduct.confirm') }}</el-button> -->
                            <el-button 
                                :disabled="comfirLoading || countdown > 0" 
                                class="pay_inner" 
                                @click="comfirOrder">
                                {{ countdown > 0 ? $t('ChooseProduct.confirm') + ` (${countdown}s)` : $t('ChooseProduct.confirm') }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 步骤3 订单支付-->
            <div class="modalView_pop" v-else-if="stepIndex == 2">
                <div class="modalView_pop_l">
                    <img class="modalView_pop_l_polygon_1" src="@/assets/images/polygon_1.png"/>
                    <img class="modalView_pop_l_polygon_2" src="@/assets/images/polygon_2.png"/>
                    <div class="modalView_pop_l_view">
                        <div class="modalView_pop_l_view_t">
                            <div class="modalView_pop_l_view_t_1">
                                <img v-if="featureName == 'tpc'" class="modalView_pop_l_view_t_3_img" src="@/assets/images/modalView_pop_l_view_t_1_img.png" alt="">
                                <img v-else-if="featureName == 'tzj'" class="modalView_pop_l_view_t_3_img" src="@/assets/images/modalView_pop_l_view_t_2_img.png" alt="">
                            </div>
                            <div class="modalView_pop_l_view_t_2"> —— {{ $t('ChooseProduct.disruptiveService') }}</div>
                        </div>
                        <div class="modalView_pop_l_view_b">
                            <div class="modalView_pop_l_view_b_2 marb0">
                                <div class="modalView_pop_b_l_v_d_title_order">{{ $t('ChooseProduct.confirmOrderInfo') }}</div>
                            </div>
                            <div class="modalView_pop_l_view_b_4">
                                <div class="modalView_pop_l_view_b_4_t">
                                    <span>{{ $t('ChooseProduct.orderNumber') }}：{{ payInfo.order_id ? payInfo.order_id : '' }}</span>
                                    <span class="bold700">{{ $t('ChooseProduct.payStatus') }}</span>
                                </div>
                                <div class="modalView_pop_l_view_b_4_m">
                                    <div class="modalView_pop_l_view_b_4_m_l">
                                        <img class="modalView_pop_l_view_b_4_m_l_img" src="../assets/images/order_img.png"/>
                                    </div>
                                    <div class="modalView_pop_l_view_b_4_m_r">
                                        <div class="modalView_pop_l_view_b_4_m_r_t" v-if="featureName == 'tpc'">
                                            <div class="modalView_pop_l_view_b_4_m_r_t_v">
                                                <span>{{ $t('ChooseProduct.scope') }}：</span>
                                                <span class="bold700">{{ payInfo?.scope == 0 ? $t('ChooseProduct.scope_list[0].name') : payInfo?.scope == 1 ? $t('ChooseProduct.scope_list[1].name') : '' }}</span>
                                            </div>
                                            <div class="modalView_pop_l_view_b_4_m_r_t_v">
                                                <span>{{ $t('ChooseProduct.address_limit') }}：</span>
                                                <span class="bold700">{{ payInfo.address_limit ? payInfo.address_limit : '' }}</span>
                                            </div>
                                            <div class="modalView_pop_l_view_b_4_m_r_t_v">
                                                <span>{{ $t('ChooseProduct.source_limit') }}：</span>
                                                <span class="bold700">{{ payInfo?.source_limit == 0 ? "≤100" : payInfo?.source_limit == 1 ? "101-500" : payInfo?.source_limit == 2 ? "＞500" :'' }}</span>
                                            </div>
                                        </div>
                                        <div class="modalView_pop_l_view_b_4_m_r_t" v-else-if="featureName == 'tzj'">
                                            <div class="modalView_pop_l_view_b_4_m_r_t_v">
                                                <span>核算边界：</span>
                                                <span class="bold700">从摇篮到大门</span>
                                            </div>
                                            <div class="modalView_pop_l_view_b_4_m_r_t_v">
                                                <span>产品数量：</span>
                                                <span class="bold700">1</span>
                                            </div>
                                            <div class="modalView_pop_l_view_b_4_m_r_t_v">
                                                <span>{{ featureName == 'tzj' ? $t('ChooseProduct.zjsource_limit') : $t('ChooseProduct.source_limit')}}：</span>
                                                <span class="bold700">{{ payInfo?.source_limit == 0 ? "≤20" : payInfo?.source_limit == 1 ? "＞20" :'' }}</span>
                                            </div>
                                        </div>
                                        <div class="modalView_pop_l_view_b_4_m_r_b">
                                            <span class="bold600 fontSize24">{{ $t('ChooseProduct.payMent') }}：</span>
                                            <span class="bold600 fontSize36">{{ payInfo.total ? '￥' + payInfo.total : '' }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="modalView_pop_l_view_b_4_b">
                                    <div class="modalView_pop_l_view_b_4_b_v first-child">
                                        <div class="modalView_pop_l_view_b_4_b_v_t marginBottom16">{{ $t('ChooseProduct.invoice') }}</div>
                                        <div class="modalView_pop_l_view_b_4_b_v_b">{{ $t('ChooseProduct.invoiceDesc') }}</div>
                                        <!-- <div class="modalView_pop_l_view_b_4_b_v_b lineHeight">付款完成后请联系：customerservice@carbonneutrality-group.com</div> -->
                                    </div>
                                    <div class="modalView_pop_l_view_b_4_b_v">
                                        <div class="modalView_pop_l_view_b_4_b_v_t marginLeft25 marginBottom16">{{ $t('ChooseProduct.contractDownload') }}</div>
                                        <div class="modalView_pop_l_view_b_4_b_v_b marginLeft25">{{ $t('ChooseProduct.contractDownloadDesc') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modalView_pop_r">
                    <div class="modalView_pop_r_2">
                        <div class="modalView_pop_r_2_title_other">{{ $t('ChooseProduct.payment') }}:</div>
                        <div class="modalView_pop_r_2_choose">
                            <div :class="selectedPayment == '对公转账' ? 'modalView_pop_r_2_choose_v_1_active' : 'modalView_pop_r_2_choose_v_1'" @click="selectPayment('对公转账')">{{ $t('ChooseProduct.transfer') }}</div>
                            <div :class="selectedPayment == '扫码支付' ? 'modalView_pop_r_2_choose_v_2_active' : 'modalView_pop_r_2_choose_v_2'" @click="selectPayment('扫码支付')">{{ $t('ChooseProduct.scanCode') }}</div>
                        </div>
                        <div class="modalView_pop_r_2_account">
                            <template v-if="selectedPayment == '扫码支付'">
                                <img class="modalView_pop_r_2_account_code" src="@/assets/images/code.png"/>
                            </template>
                            <template v-else>
                                <div class="modalView_pop_r_2_account_view">
                                    <div class="modalView_pop_r_2_account_title">{{ $t('ChooseProduct.accountName') }}：</div>
                                    <div class="modalView_pop_r_2_account_label">{{ $t('ChooseProduct.accountNameDesc') }}</div>
                                    <div class="modalView_pop_r_2_account_title">{{ $t('ChooseProduct.accountBank') }}：</div>
                                    <div class="modalView_pop_r_2_account_label">{{ $t('ChooseProduct.accountBankDesc') }}</div>
                                    <div class="modalView_pop_r_2_account_title">{{ $t('ChooseProduct.accountNumber') }}：</div>
                                    <div class="modalView_pop_r_2_account_label">31050170360000006651</div>
                                    <div class="modalView_pop_r_2_account_copy">
                                        <div class="modalView_pop_r_2_account_copy_btn" @click="copyInfo">{{ $t('ChooseProduct.copyInfo') }}</div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="modalView_pop_r_2_notes">
                            <div class="modalView_pop_r_2_notes_title">
                                <div class="modalView_pop_r_2_notes_title_red"></div>
                                {{ $t('ChooseProduct.payNote') }}
                            </div>
                            <div class="modalView_pop_r_2_notes_text">{{ payInfo.order_id ? payInfo.order_id : '' }}</div>
                        </div>
                        <div class="modalView_pop_r_2_notes_other">
                            {{ $t('ChooseProduct.payInfo') }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 步骤4 完成-->
             <div class="modalView_pop" v-else-if="stepIndex == 3">
                <div class="modalView_pop_otherView">
                    <div class="modalView_pop_otherView_t">
                        <div class="modalView_pop_l_view_t_1">
                            <div class="modalView_pop_l_view_t_3_text">碳盘查Agent</div>
                            <!-- <img class="modalView_pop_l_view_t_3_img" src="@/assets/images/modalView_pop_l_view_t_1_img.png" alt=""> -->
                        </div>
                        <div class="modalView_pop_l_view_t_2"> —— 颠覆性的碳盘查服务</div>
                    </div>
                    <div class="modalView_pop_otherView_b">
                        <div class="modalView_pop_otherView_b_iconView">
                            <img class="modalView_pop_otherView_b_iconView_img" src="../assets/images/success.gif"/>
                        </div>
                        <div class="modalView_pop_otherView_b_text1">支付成功！您的套餐已购买成功</div>
                        <div class="modalView_pop_otherView_b_text2">可在账户-我的服务中查看</div>
                    </div>
                </div>
             </div>
        </div>
        <Contract ref="contractRef" @success="creatContract"/>
        <!-- <PayPop v-if="showPop" :isShow="showPop" :payInfo="payInfo" @close="closePop"></PayPop> -->
    </div>
</template>

<script>
// import PayPop from './payPop.vue';
import { creatPermissions, getFeatures, upgrade, createContractPreviewFile } from '@/api/index';
import { mapState, mapMutations } from "vuex";
import Contract from './Contract.vue';
// import { pdf } from 'vue-pdf'
export default {
  components: {
    Contract,
    // pdf
  },
  data() {
    return {
        isVisible: false, // 控制弹窗的显示状态
        activeIndex: 1,
        payInfo: {
            scope: null, // 范围
            address_limit: '', // 公司
            source_limit: null, // 排放源
            total: '', // 总价
        },
        stepIndex: 0, // 当前步骤
        basePrice: 9800, // 基础价格
        isPay: false, // 能否支付
        showPop: false, // 控制支付弹窗的显示状态
        isDown: false, // 判断是否滚动到底部
        selectedPayment: '对公转账', // 选择的支付方式
        featureName: "tpc",
        htUrl: "",
        comfirLoading: false,
        countdown: 0, // 倒计时秒数
        countdownTimer: null, // 倒计时定时器
    }
  },
  methods: {
    ...mapMutations(["setOrderInfo"]),
    showModal(productInfo, index, featureName) {
        this.isVisible = true; // 假设 isVisible 控制弹窗的显示状态
        if(productInfo && index){
            if(index == 2){
                this.payInfo.order_id = productInfo.id;
                this.payInfo.total = productInfo.amount;
                this.payInfo.scope = productInfo.permission_config.scope;
                this.payInfo.address_limit = productInfo.permission_config.address_limit;
                this.payInfo.source_limit = productInfo.permission_config.source_limit;
                this.stepIndex = index;
            }else{
                this.payInfo.total = productInfo.config.amount;
                this.payInfo.scope = productInfo.config.scope;
                this.payInfo.address_limit = productInfo.config.address_limit;
                this.payInfo.source_limit = productInfo.config.source_limit;
                this.payInfo.old_order_id = productInfo.config.old_order_id;
                this.featureName = productInfo.config.featureName
                // this.confirm()
                this.secondAdd()
                // 显示步骤2时立即开始倒计时
                this.startCountdown();
            }
        }
        this.featureName = featureName;
        document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    hideModal() {
        this.isVisible = false; // 假设 isVisible 控制弹窗的显示状态
        document.body.style.overflow = ''; // 恢复页面滚动
        this.payInfo.scope = null;
        this.payInfo.address_limit = '';
        this.payInfo.source_limit = null;
        this.payInfo.total = '';
        this.payInfo.old_order_id = ""
        this.stepIndex = 0; // 重置步骤
        this.stopCountdown(); // 停止倒计时
        this.$emit('update');
    },
    // 选择范围
    chooseF(value) {
        this.payInfo.scope = value;
        this.totalPrice()
        this.checkPay()
    },
    // 选择排放源
    chooseE(value) {
        this.payInfo.source_limit = value;
        this.totalPrice()
        this.checkPay()
    },
    // 选择排放源数量
    chooseSl(value) {
        this.payInfo.source_limit = value;
        this.totalPrice()
        this.checkPay()
    },
    // 选择公司数量
    chooseC() {
        // 移除首尾空格
        this.payInfo.address_limit = this.payInfo.address_limit.trim();
        // 正则表达式校验：正整数（不含0、e和符号）
        const regex = /^[1-9]\d*$/;
        if (!regex.test(this.payInfo.address_limit)) {
            if (this.payInfo.address_limit.startsWith('0') && this.payInfo.address_limit.length > 1) {
                this.payInfo.address_limit = this.payInfo.address_limit.slice(1); // 移除开头的0
            }
        }
        if(this.payInfo.address_limit > 1000){
            this.payInfo.address_limit = 1000;
        }
        this.checkPay()
        this.totalPrice()
    },

    // 选择购买次数
    chooseUseLimit() {
        this.payInfo.source_limit = this.payInfo.source_limit.trim();
        // 正则表达式校验：正整数（不含0、e和符号）
        const regex = /^[1-9]\d*$/;
        if (!regex.test(this.payInfo.source_limit)) {
            if (this.payInfo.source_limit.startsWith('0') && this.payInfo.source_limit.length > 1) {
                this.payInfo.source_limit = this.payInfo.source_limit.slice(1); // 移除开头的0
            }
        }
        this.checkPay()
        this.totalPrice()
    },
    // 计算总价
    totalPrice() {
        if(this.featureName == "tpc"){
            // 范围系数
            let rangeFactor = this.payInfo.scope === 0 ? 1 : this.payInfo.scope === 1 ? 1.5 : 0;
            // 排放源系数
            let emissionFactor = this.payInfo.source_limit === 0 ? 1 : this.payInfo.source_limit === 1 ? 2 : this.payInfo.source_limit === 2 ? 3 : "";
            // 总价 = 2000 × 范围系数 × √公司系数 × 排放源系数 × 购买资格数暂时为1
            if(this.payInfo.address_limit == '' || this.payInfo.address_limit == 0 || rangeFactor == "" || emissionFactor == ""){
                this.payInfo.total = "";
            }else{
                this.payInfo.total = parseFloat(this.basePrice * rangeFactor * Math.sqrt(Number(this.payInfo.address_limit)) * emissionFactor * 1).toFixed(2);
            }
        }else if(this.featureName == "tzj"){
            if(this.payInfo.source_limit == null){
                this.payInfo.total = "";
            }else{
                this.payInfo.total = this.payInfo.source_limit === 0 ? 999 : this.payInfo.source_limit === 1 ? 5999 : 0;
            }
        }
    },
    // 检查能否支付
    checkPay() {
        if(this.featureName == "tpc"){
            if(this.payInfo.scope !== null && this.payInfo.scope != undefined &&
                this.payInfo.address_limit && this.payInfo.source_limit !== null &&
                this.payInfo.source_limit != undefined){
                this.isPay = true;
            }else{
                this.isPay = false;
            }
        }else if(this.featureName == "tzj"){
            if(this.payInfo.source_limit !==null){
                this.isPay = true;
            }else{
                this.isPay = false;
            }
        }
    },
    //匹配featureId
    async searchFeatureId() {
        try {
            const res = await getFeatures();
            if (res.status === 200) {
                const feature = res.data.data.find(item => item.code === this.featureName);
                if (feature) {
                    return feature.id; // 返回 feature.id
                } else {
                    this.$message({
                        message: this.$t('serviceI18n.get_feature_id_failed'),
                        type: 'error'
                    });
                    throw new Error(this.$t('serviceI18n.get_feature_id_failed'));
                }
            } else {
            this.$message({
                message: res.data.msg,
                type: 'error'
            });
            throw new Error(res.data.msg);
            }
        } catch (error) {
            throw error;
        }
    },
    // 确认，第一步
    confirm() {
        if(this.featureName == "tpc"){
            if(this.payInfo.address_limit == 0) {
                this.$message({
                    message: this.$t('ChooseProduct.addressLimitFail'),
                    type: 'error'
                });
                return
            }
        }else if(this.featureName == "tzj"){
            if(this.payInfo.source_limit == null) {
                this.$message({
                    message: '请选择您产品的原辅材料数量？',
                    type: 'error'
                });
                return
            }
        }
        if(!this.isPay){
            return false
        }
        this.setOrderInfo(this.payInfo);
        this.$refs.contractRef.showModal()
        this.$refs.contractRef.submit()
    },
    focusInput() {
        this.$refs.limitInput?.focus();
    },
    //处理加购直接生成合同
    secondAdd(){
        let config = {}
        if(this.featureName == "tpc"){
            config = {
                scope: this.payInfo.scope, //盘查范围
                address_limit: this.payInfo.address_limit, //业务场所数量
                source_limit: this.payInfo.source_limit, //排放源数量
            }
        }else if(this.featureName == "tzj"){
            config = {                
                source_limit: this.payInfo.source_limit, //购买次数
            }
        }
        createContractPreviewFile(this.payInfo.old_order_id, {
            config
        }).then(res => {
            if (res.data) {
                this.$message({
                    message: this.$t('ChooseProduct.contractSuccess'),
                    type: 'success'
                });
                const blob = new Blob([res.data], { type: 'application/pdf' });
                this.creatContract(URL.createObjectURL(blob))
            }else{
                this.$message({
                    message: this.$t('ChooseProduct.contractFail'),
                    type: 'error'
                });
            }
        })
    },
    //创建合同
    creatContract(value, companyInfo){
        this.stepIndex = 1;
        this.changeType(1)
        this.companyInfo = companyInfo ? companyInfo : null;
        if(value){
            this.htUrl = value;
        }else{
            this.$message({
                message: this.$t('ChooseProduct.contractFail'),
                type: 'error'
            })
            return
        }
    },
    // 开始倒计时
    startCountdown() {
        // 清除之前的定时器
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
        }
        this.countdown = 10;
        this.countdownTimer = setInterval(() => {
            if (this.countdown > 0) {
                this.countdown--;
            } else {
                this.stopCountdown();
            }
        }, 1000);
    },
    
    // 停止倒计时
    stopCountdown() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
        }
        this.countdown = 0;
    },
    // 确认订单，第二步
    async comfirOrder() {
        // 如果倒计时未结束，不允许点击
        if (this.countdown > 0) {
            return false;
        }
        this.comfirLoading = true;
        const featureId = await this.searchFeatureId();
        let config = {}
        if(this.featureName == "tpc"){
            config = {
                scope: this.payInfo.scope, //盘查范围
                address_limit: this.payInfo.address_limit, //业务场所数量
                source_limit: this.payInfo.source_limit, //排放源数量
            }
        }else if(this.featureName == "tzj"){
            config = {                
                source_limit: this.payInfo.source_limit, //购买次数
            }
        }
        if(this.payInfo.old_order_id){
            // 升级订单
            upgrade(this.payInfo.old_order_id, {
                config
            }).then((res) => {
                if(res.data.code == 200){
                    this.comfirLoading = false;
                    this.stepIndex = 2; // 更新当前步骤
                    this.changeType(2)
                    this.payInfo.order_id = res.data.data.id;
                    this.payInfo.total = res.data.data.amount;
                    this.payInfo.scope = res.data.data.permission_config.scope;
                    this.payInfo.address_limit = res.data.data.permission_config.address_limit;
                    this.payInfo.source_limit = res.data.data.permission_config.source_limit;
                }else{
                    this.$message({
                        message: res.data.data,
                        type: 'error'
                    })
                    this.comfirLoading = false;
                }
            }).catch((error) => {
                console.error('生成套餐订单失败', error);
            });
        }else{
            // 新购订单
            creatPermissions({
                feature_id: featureId, //产品类型ID
                config,
                credit_code: this.companyInfo.creditCode, //统一信用代码
                company: this.companyInfo.company ? this.companyInfo.company : this.companyInfo.name, //公司名称
                user_phone: this.companyInfo.user_phone, //联系方式
                address: this.companyInfo.address, //地址
            }).then((res) => {
                if(res.data.code == 200){
                    this.comfirLoading = false;
                    this.stepIndex = 2; // 更新当前步骤
                    this.changeType(2)
                    this.payInfo.order_id = res.data.data.id;
                    this.payInfo.total = res.data.data.amount;
                    this.payInfo.scope = res.data.data.permission_config.scope;
                    this.payInfo.address_limit = res.data.data.permission_config.address_limit;
                    this.payInfo.source_limit = res.data.data.permission_config.source_limit;
                }else{
                    this.$message({
                        message: res.data.data,
                        type: 'error'
                    })
                    this.comfirLoading = false;
                }
            }).catch((error) => {
                console.error('生成升级套餐订单失败', error);
            });
        }
    },
    // 支付，第三步
    pay() {
        this.stepIndex = 3; // 更新当前步骤
    },
    // 关闭支付弹窗
    closePop() {
        this.showPop = false;
    },
    // 切换步骤
    changeType(index) {
        // this.stepIndex = index; // 更新当前步骤
        if(this.stepIndex == 1){
            this.$nextTick(() => {
                this.$refs.htContent.addEventListener('scroll', this.checkScrollBottom);
                this.checkScrollBottom();
            })
        }
        // 如果切换到步骤2（确认订单），开始倒计时
        if (index === 1) {
            this.startCountdown();
        }
    },
    checkScrollBottom() {
        const content = this.$refs.htContent;
        if (content) {
            const isBottom = content.scrollHeight - content.scrollTop === content.clientHeight;
            this.isDown = isBottom;
        }
    },
    // 获取订单信息
    getOrderInfo() {
        if(this.orderInfo){
            this.payInfo = this.orderInfo;
        }
    },
    // 选择支付方式
    selectPayment(payment) {
        this.selectedPayment = payment; // 更新选中的支付方式
    },
    // 复制信息
    copyInfo() {
        const text = `账户名：中碳普惠云科技有限公司\n开户银行：中国建设银行股份有限公司上海黄浦支行\n账号：31050170360000006651\n订单号：${this.payInfo.order_id}`;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(() => {
            this.$message({
                message: this.$t('ChooseProduct.copySuccess'),
                type: 'success'
            });
            }).catch(() => {
            this.fallbackCopyTextToClipboard(text);
            });
        } else {
            this.fallbackCopyTextToClipboard(text);
        }
    },
    fallbackCopyTextToClipboard(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            const successful = document.execCommand('copy');
            if (successful) {
            this.$message({
                message: this.$t('ChooseProduct.copySuccess'),
                type: 'success'
            });
            } else {
            this.$message({
                message: this.$t('ChooseProduct.copyFail'),
                type: 'error'
            });
            }
        } catch (err) {
            this.$message({
            message: this.$t('ChooseProduct.copyFail'),
            type: 'error'
            });
        }
        document.body.removeChild(textarea);
    },
  },
  computed: {
    ...mapState(["userInfo", "orderInfo"]),
    stepList() {
        return this.$t('ChooseProduct.productList');
    },
  },
  mounted() {
    // this.getOrderInfo()
  },
  beforeDestroy() {
    const content = this.$refs.htContent;
    if (content) {
      content.removeEventListener('scroll', this.checkScrollBottom);
    }
  },
}
</script>

<style scoped lang="scss">
.back{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(33, 33, 33, 0.5);
    height: 100vh;
    z-index: 999;
}
.modalView {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
    background: var(--global-background);
    width: 1220px;
    height: 725px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    z-index: 1001;

    .stepView {
        width: 100%;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: center;


        .steps {
            height: 100%;
            align-items: center;
            justify-content: center;
            z-index: 1;
        }

        .stepTitle {
            font-size: 32px;
            font-weight: 600;
            color: #fff;
        }

        .step {
            width: max-content;
            cursor: default;
        }

        .flexStyle {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .borderLeft {
            // border-bottom: 2px dashed #fff;
            // min-width: 240px;
            // height: 50px;
            // display: flex;
            // align-items: center;
            // margin: 0 8px;

            .borderLeftText{
                padding-bottom: 15px;
                color: #fff;
                font-size: 20px;
                font-weight: 500;
                padding-left: 5px;
            }
        }

        .borderLeftP {
            border-bottom: 2px dashed #fff;
            min-width: 180px;
            height: 23px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .borderLeftPFinish{
            height: 23px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .unFinishBorder {
            border-bottom: 2px solid rgba(255, 255, 255, 0.5);
            min-width: 180px;
            height: 23px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .activeBorderP {
            border-bottom: 2px dashed #fff;
            min-width: 180px;
            height: 23px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .activeBorder i {
            font-size: 18px;
            border-bottom: 2px solid #fff;
        }

        .finishBorder {
            border-bottom: 2px solid #fff;
        }

        .circle{
            width: 35px;
            height: 35px;
            border-radius: 50%;
            background-color: transparent;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #fff;
        }

        .step .icon {
            width: 35px;
            height: 35px;
            font-size: 35px;
        }
        .step span {
            flex: 1;
        }
        .iconBorder {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.5);
        }

        /* .activeClass {
            border: 5px solid rgba(201, 232, 255, 1);
            background: #fff;
        } */

        /* .focusClass {
            color: #fff;
            background-color: #0095ff;
            width: 140px;
            margin: auto 7.5px;
            cursor: default;
        } */

        .contentBox {
            width: 250px;
            min-height: 350px;
            border-radius: 20px;
            padding: 11px;
            margin: 10px 20px;
            background: linear-gradient(180deg, rgba(222, 255, 231, 0.75) 0%, rgba(219, 255, 240, 0.75) 50%, rgba(219, 255, 255, 0.75) 100%);
        }

        .content {
            max-height: 350px;
            min-height: 350px;
            width: 100%;
            overflow-y: auto;
            /* 隐藏滚动条 */
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE 10+ */
        }
        .content::-webkit-scrollbar {
            display: none; /* Chrome, Safari, Edge */
        }

        ::v-deep .content p {
            margin-bottom: 15px;
        }

        .content_title {
            font-weight: 900;
            color: rgba(53, 131, 98, 1);
        }

        .content_info {
            font-weight: normal;
            color: rgba(53, 131, 98, 1);
        }

        .el-icon-caret-left{
            font-size: 50px;
        }

        .el-icon-caret-right{
            font-size: 25px;
        }

        .el-icon-loading{
            font-size: 35px;
            color: #fff;
        }

        .el-icon-success{
            width: 28px!important;
            height: 28px!important;
            font-size: 28px!important;
            color: #fff;
        }
    }


    .modalView_pop {
        width: calc(100% - 20px);
        height: calc(100% - 20px - 100px);
        background-color: #ffffff; /* 设置不透明的白色底色 */
        background-image: var(--global-inner-background); /* 渐变叠加在白色底色上 */
        border-radius: 20px;
        display: flex;

        .modalView_pop_l {
            width: 836px;
            height: 100%;
            position: relative;

            .modalView_pop_l_polygon_1{
                position: absolute;
                width: 32px;
                height: 32px;
                top: 0;
                right: -4px
            }

            .modalView_pop_l_polygon_2{
                position: absolute;
                width: 32px;
                height: 32px;
                bottom: 0;
                right: -4px;
            }

            .modalView_pop_l_view {
                width: 790px;
                height: 100%;
                margin: 0 10px 0 35px;
                border-left: 2px dashed #E3E6E8;
                border-right: 2px dashed #E3E6E8;

                .modalView_pop_l_view_t {
                    width: 100%;
                    border-bottom: 2px dashed #E3E6E8;
                    height: 140px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;


                    .modalView_pop_l_view_t_1 {
                        width: 223px;
                        height: 46px;
                        margin-left: 33px;

                        .modalView_pop_l_view_t_1_img{
                            width:159px;
                            height: 42px;
                        }

                        .modalView_pop_l_view_t_3_img{
                            width: 223px;
                            height: 46px;
                        }

                        .modalView_pop_l_view_t_3_text{
                            font-size: 35px;
                            color: rgba(33, 33, 33, 1);
                            font-weight: 500;
                        }
                    }

                    .modalView_pop_l_view_t_2 {
                        font-size: 18px;
                        color: rgba(0, 0, 0, 1);
                        font-weight: 500;
                        margin-left: 35px;
                        // margin-top: 10px;
                    }
                }

                .modalView_pop_l_view_b {
                    width: 100%;
                    height: calc(100% - 160px);
                    background: url('@/assets/images/server_back.png') no-repeat;
                    background-size: 100% 80%;
                    background-position: 0px 40px;
                    position: relative;

                    .modalView_pop_l_view_b_1{
                        position: absolute;
                        top: 65px;
                        left: 20px;

                        .modalView_pop_l_view_b_1_text1{
                            font-size: 24px;
                            font-weight: 600;
                            color: rgba(58, 83, 36, 1);
                        }

                        .modalView_pop_l_view_b_1_text2{
                            font-size: 20px;
                            font-weight: 500;
                            color: rgba(0, 0, 0, 1);
                            text-indent: 15px;
                            margin-bottom: 25px;
                        }
                    }

                    .modalView_pop_l_view_b_2{
                        margin:20px 10px 30px 33px;
                        height: auto;
                        overflow-y: hidden;

                        .modalView_pop_b_l_v_d_title{
                            font-size: 18px;
                            font-weight: 600;
                            // color: rgba(58, 83, 36, 1);
                            color: rgba(18, 121, 200, 0.60);
                            letter-spacing: 2px;
                            margin-bottom: 35px;
                        }

                        .modalView_pop_b_l_v_d_title_order{
                            font-size: 30px;
                            font-weight: 700;
                            color: #052031;
                            margin-bottom: 10px;
                        }

                        .modalView_pop_b_l_v_d_buy{
                            max-height: 410px; /* 设置最大高度，具体值根据需求调整 */
                            overflow-y: auto; /* 启用垂直滚动条 */
                            padding-right: 10px; /* 为滚动条预留空间，避免内容被遮挡 */
                            scrollbar-width: thin; /* 优化滚动条宽度（Firefox） */
                            scrollbar-color: rgba(117, 117, 117, 0.5) transparent;
                            position: relative;

                            .modalView_pop_b_l_v_d_buy_view{
                                width: 100%;
                                height: 86px;
                                margin-bottom: 40px;

                                .modalView_pop_b_l_v_d_buy_view_title{
                                    font-size: 20px;
                                    color: rgba(0, 0, 0, 1);

                                    span{
                                        font-size: 36px;
                                        font-weight: 700;
                                        color: rgba(33, 33, 33, 1);
                                    }
                                }

                                .modalView_pop_b_l_v_d_buy_view_content{
                                    display: flex;
                                    align-items: center;
                                    margin-top: 5px;
                                    // justify-content: center;

                                    .modalView_pop_b_l_v_d_buy_view_content_choose{
                                        width: max-content;
                                        max-width: 240px;
                                        height: 40px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        border: 1px solid #1279C8;
                                        border-radius: 5px;
                                        padding: 0 40px;
                                        cursor: pointer;
                                        font-size: 20px;
                                        margin-right: 7px;
                                        color: #1279C8;
                                    }

                                    .activeF{
                                        // background: rgba(86, 198, 151, 1);
                                        background: var(--global-primary);
                                        color: #fff;
                                        font-weight: 700;
                                        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                                    }

                                    .inputView{
                                        width: 106px;
                                        height: 40px;
                                        text-align: center;
                                        color: #000; /* 关键！ */
                                        background: #fff;
                                        border: 1px solid var(--global-primary);
                                        padding: 0;
                                        font-size: 20px;
                                        outline: none;
                                        caret-color: var(--global-primary);
                                        border-radius: 5px;
                                    }

                                    .inputViewFocus{
                                        padding: 0!important;
                                        // background: rgba(86, 198, 151, 1);
                                        background: var(--global-primary);
                                        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                                        color: #fff;
                                        border: 1px solid #1279C8!important;
                                        caret-color: #fff;
                                    }
                                }
                            }

                            .modalView_pop_b_l_v_d_buy_btn{
                                width: 300px;
                                height: 45px;
                                background: transparent;
                                border-radius: 20px;
                                display: flex;
                                align-items: center;
                                color: #212121;
                                justify-content: center;
                                position: fixed;
                                font-size: 22px;
                                font-weight: 700;
                                bottom: 80px;
                                left: 245px;
                                border: 1px solid #3A5324;
                                cursor: pointer;
                            }

                            .iframeView{
                                width: 100%;

                                .iframeViewContent{
                                    width: 100%;
                                    height: 400px;
                                }

                            }
                        }
                    }

                    .marb0{
                        margin-bottom: 0px!important;
                    }

                    .modalView_pop_l_view_b_3{
                        position: absolute;
                        top: 30px;
                        left: 20px;

                        .modalView_pop_l_view_b_3_text1{
                            font-size: 24px;
                            font-weight: 600;
                            color: rgba(58, 83, 36, 1);
                        }

                        .modalView_pop_l_view_b_3_text2{
                            font-size: 18px;
                            font-weight: 500;
                            color: rgba(0, 0, 0, 1);
                            margin-bottom: 25px;
                        }
                    }

                    .modalView_pop_l_view_b_4{
                        width:718px;
                        height: 387px;
                        border: 1px solid rgba(217, 217, 217, 1);
                        border-radius: 10px;
                        margin-left: 33px;

                        .modalView_pop_l_view_b_4_t{
                            height: 40px;
                            background: rgba(247, 247, 247, 1);
                            padding: 0 20px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: 18px;
                            border-top-left-radius: 10px;
                            border-top-right-radius: 10px;
                        }

                        .modalView_pop_l_view_b_4_m{
                            height: 247px;
                            background: rgba(255, 255, 255, 0.75);
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .modalView_pop_l_view_b_4_m_l{
                                width: 140px;
                                height: 220px;
                                margin-left: 20px;

                                .modalView_pop_l_view_b_4_m_l_img{
                                    width: 140px;
                                    height: 220px;
                                }
                            }

                            .modalView_pop_l_view_b_4_m_r{
                                display: flex;
                                width: 495px;
                                flex-direction: column;
                                margin-right: 22px;
                                height: 100%;

                                .modalView_pop_l_view_b_4_m_r_t{
                                    width: 100%;
                                    height: 166px;
                                    border-bottom: 1px solid rgba(217, 217, 217, 1);
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: center;

                                    .modalView_pop_l_view_b_4_m_r_t_v{
                                        width: 100%;
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        font-size: 20px;
                                        height: 35px;
                                    }
                                }

                                .modalView_pop_l_view_b_4_m_r_b{
                                    height: 80px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                }
                            }
                        }

                        .modalView_pop_l_view_b_4_b{
                            height: 98px;
                            background: rgba(247, 247, 247, 1);
                            padding: 0 20px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            border-top: 1px solid rgba(227, 227, 227, 1);
                            border-bottom-left-radius: 10px;
                            border-bottom-right-radius: 10px;

                            .modalView_pop_l_view_b_4_b_v{
                                display: flex;
                                flex-direction: column;
                                width: 50%;
                                height: 100%;

                                .modalView_pop_l_view_b_4_b_v_t{
                                    height: 27px;
                                    margin-top:11px;
                                    font-size: 18px;
                                    font-weight: 600;
                                }

                                .modalView_pop_l_view_b_4_b_v_b{
                                    font-size: 16px;
                                    font-weight: 500;
                                    color: rgba(117, 117, 117, 1);
                                }
                            }

                            .first-child{
                                border-right: 1px solid rgba(227, 227, 227, 1);
                            }
                        }

                        .marginBottom16{
                            margin-bottom: 16px;
                        }

                        .bold700{
                            font-weight: 700;
                        }

                        .bold600{
                            font-weight: 600;
                        }

                        .fontSize24{
                            font-size: 24px;
                        }

                        .fontSize36{
                            font-size: 36px;
                            font-family: Impact;
                        }

                        .marginLeft25{
                            margin-left: 25px;
                        }

                        .lineHeight{
                            line-height: 16px;
                        }

                    }
                }
            }
        }

        .modalView_pop_r {
            width: 380px;
            height: 100%;

            .modalView_pop_r_1{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;

                .modalView_pop_r_1_t{
                    width: 308px;
                    height: 242px;
                    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                    background: var(--global-primary);
                    border-radius: 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-around;
                    cursor: pointer;

                    .modalView_pop_r_1_t_img{
                        width: 278px;
                        height: 156px;
                    }

                    .modalView_pop_r_1_t_v{
                        width: 278px;
                        height: 50px;
                        background: linear-gradient(180deg, rgba(222, 255, 231, 0.5) 0%, rgba(219, 255, 240, 0.5) 50%, rgba(219, 255, 255, 0.5) 100%);
                        border-radius: 30px;
                        font-size: 20px;
                        color: #fff;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .modalView_pop_r_1_t_v_img{
                            width: 25px;
                            height: 25px;
                            margin-left: 10px;
                        }
                    }
                }

                .modalView_pop_r_1_b{
                    width: 170px;
                    height: 64px;
                    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                    background: var(--global-primary);
                    border-radius: 10px;
                    margin-top: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    font-size: 24px;
                    color: #fff;
                    font-weight: 500;
                }

                .modalView_pop_r_1_position{
                    position: absolute;
                    right: 16px;
                    bottom: 100px;
                    width: 96px;
                    height: 109px;
                    z-index: 1;
                }

                .modalView_pop_r_1_position_img{
                    position: absolute;
                    right: 33px;
                    bottom: 95px;
                    width: 98px;
                    height: 18px;
                }
            }

            .modalView_pop_r_2{
                // width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                margin-left: 25px;
                margin-right: 25px;

                .modalView_pop_r_2_title{
                    height: 140px;
                    border-bottom: 2px dashed #E3E6E8;
                    font-size: 32px;
                    color: rgba(0, 0, 0, 1);
                    font-weight: 700;
                    margin-bottom: 60px;
                    padding-top: 70px;
                }

                .modalView_pop_r_2_title_other{
                    height: 140px;
                    border-bottom: 2px dashed #E3E6E8;
                    font-size: 32px;
                    color: #052031;
                    font-weight: 700;
                    margin-bottom: 20px;
                    padding-top: 70px;
                }

                .modalView_pop_r_2_choose{
                   height: 47px;
                    width: 100%;
                    display: flex;
                    align-items: flex-end;
                    // justify-content: space-between;

                    .modalView_pop_r_2_choose_v_1{
                        display: flex;
                        align-items: center;
                        font-size: 18px;
                        font-weight: 700;
                        background: #CAEAEA;
                        position: relative;
                        height: 40px;
                        transition: all 0.2s ease;
                        outline: none;
                        clip-path: polygon(0 0, 80% 0, 100% 100%, 0% 100%);
                        padding-left: 22px;
                        width: 160px;
                        border-top-left-radius: 10px;
                    }

                    .modalView_pop_r_2_choose_v_1_active{
                        display: flex;
                        align-items: center;
                        font-size: 18px;
                        font-weight: 700;
                        background: #D1ECFD;
                        position: relative;
                        height: 47px;
                        transition: all 0.2s ease;
                        outline: none;
                        clip-path: polygon(0 0, 70% 0, 100% 100%, 0% 100%);
                        padding-left: 22px;
                        width: 160px;
                        border-top-left-radius: 10px;
                    }

                    .modalView_pop_r_2_choose_v_2{
                        display: flex;
                        align-items: center;
                        font-size: 18px;
                        font-weight: 700;
                        // background: #CAEAEA;
                        background: #93A8B5;
                        position: relative;
                        height: 40px;
                        transition: all 0.2s ease;
                        outline: none;
                        clip-path: polygon(0 0, 70% 0, 100% 100%, 20% 100%);
                        margin-left: -40px;
                        padding-left: 40px;
                        width: 160px;
                    }

                    .modalView_pop_r_2_choose_v_2_active{
                        display: flex;
                        align-items: center;
                        font-size: 18px;
                        font-weight: 700;
                        background: #D1ECFD;
                        position: relative;
                        height: 47px;
                        transition: all 0.2s ease;
                        outline: none;
                        clip-path: polygon(0 0, 70% 0, 100% 100%, 20% 100%);
                        margin-left: -40px;
                        padding-left: 40px;
                        width: 160px;
                    }

                }

                .modalView_pop_r_2_account{
                    width: 320px;
                    height: 256px;
                    // background: linear-gradient(180deg, #D1ECFD 0%, #DBFFF0 50%, #DBFFFF 100%);
                    background: #D1ECFD;
                    border-radius:  0px 10px 10px 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .modalView_pop_r_2_account_code{
                        width:140px;
                        height: 176px;
                    }

                    .modalView_pop_r_2_account_view{
                        width: 300px;
                        height: 233px;
                        border-radius: 10px;
                        // background: #fff;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-evenly;
                        margin:10px;

                        .modalView_pop_r_2_account_title{
                            font-size: 18px;
                            font-weight: 700;
                            color: rgba(0, 0, 0, 1);
                            padding-left:12px;
                        }

                        .modalView_pop_r_2_account_label{
                            font-size: 14px;
                            font-weight: 500;
                            color: rgba(0, 0, 0, 1);
                            padding-left:26px;
                        }

                        .modalView_pop_r_2_account_copy{
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .modalView_pop_r_2_account_copy_btn{
                                width: 160px;
                                height: 30px;
                                // background: rgba(242, 242, 242, 1);
                                background: var(--global-primary);
                                border-radius: 16px;
                                font-size: 18px;
                                color: #fff;
                                font-weight: 500;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .modalView_pop_r_2_notes{
                    margin-top: 5px;
                    height: 40px;

                    .modalView_pop_r_2_notes_title{
                        font-size: 16px;
                        font-weight: 700;
                        color: #FF0000;
                        display: flex;
                        align-items: center;

                        .modalView_pop_r_2_notes_title_red{
                            width: 7px;
                            height: 7px;
                            border-radius: 50%;
                            background: #FF0000;
                            margin-right: 10px;
                        }
                    }

                    .modalView_pop_r_2_notes_text{
                        font-size: 16px;
                        font-weight: 700;
                        color: rgba(0, 0, 0, 1);
                    }
                }

                .modalView_pop_r_2_notes_other{
                    width:320px;
                    height: 72px;
                    // background: linear-gradient(180deg, #DEFFE7 0%, #DBFFF0 50%, #DBFFFF 100%);
                    background: #D1ECFD;
                    border-radius: 10px;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 18px;
                    padding:5px;
                    margin-top:10px;
                    color: rgba(117, 117, 117, 1);
                }

                .modalView_pop_b_r_v_1{
                    font-size: 20px;
                    color: rgba(0, 0, 0, 1);
                    margin-bottom: 5px;
                    display: flex;
                    justify-content: space-between;
                }

                .modalView_pop_b_r_v_2{
                    font-size: 20px;
                    font-weight: 600;
                    color: rgba(0, 0, 0, 1);
                    margin-top: 140px;
                }

                .modalView_pop_b_r_v_3{
                    font-size: 20px;
                    font-weight: 600;
                    color: rgba(0, 0, 0, 1);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 155px;

                    .modalView_pop_b_r_v_3_t{
                        font-family: Impact;
                        font-size: 32px!important;
                    }
                }

                .pay{
                    width: 100%;
                    height: 45px;
                    background: linear-gradient(180deg, #E4E4E4 0%, #CACACA 50%, #9E9E9E 100%);
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 24px;
                    cursor: pointer;

                    .pay_inner{
                        width: 100%;
                        height: 40px;
                        background: #F2F2F2;
                        display: flex;
                        border-radius: 16px;
                        align-items: center;
                        justify-content: center;
                        font-size: 22px;
                        color: rgba(117, 117, 117, 1);
                    }

                    ::v-deep .el-button{
                        border: none;
                    }
                }

                .activePay{
                    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                    background: var(--global-primary);

                    .pay_inner{
                        background: transparent;
                        color: #fff;
                    }
                }
            }

            .modalView_pop_r_3{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;

                .modalView_pop_r_3_1{
                    font-size: 24px;
                    color: rgba(0, 0, 0, 1);
                    font-weight: 600;
                }

                .modalView_pop_r_3_img{
                    width: 190px;
                    height: 190px;
                    margin-top: 38px;
                }

                .modalView_pop_r_3_2{
                    font-size: 18px;
                    color: rgba(0, 0, 0, 1);
                    font-weight: 500;
                    margin-top:10px;
                }

                .modalView_pop_r_3_3{
                    font-size: 18px;
                    color: rgba(0, 0, 0, 1);
                    font-weight: 500;
                    margin-top:30px;
                }

                .modalView_pop_r_3_4{
                    font-size: 12px;
                    color: rgba(0, 0, 0, 1);
                    font-weight: 500;
                }
            }
        }

        .modalView_pop_otherView{
            width: 1150px;
            height: 100%;
            margin-left:45px;
            border-left: 2px dashed #E3E6E8;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .modalView_pop_otherView_t{
                width: 100%;
                height: 150px;
                border-bottom: 2px dashed #E3E6E8;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .modalView_pop_l_view_t_1 {
                    width: 223px;
                    height: 46px;
                    margin-left: 33px;

                    .modalView_pop_l_view_t_1_img{
                        width:159px;
                        height: 42px;
                    }

                    .modalView_pop_l_view_t_3_img{
                        width: 223px;
                        height: 46px;
                    }

                    .modalView_pop_l_view_t_3_text{
                        font-size: 35px;
                        color: rgba(33, 33, 33, 1);
                        font-weight: 500;
                    }
                }

                .modalView_pop_l_view_t_2 {
                    font-size: 18px;
                    color: rgba(0, 0, 0, 1);
                    font-weight: 500;
                    margin-left: 35px;
                    // margin-top: 10px;
                }
            }

            .modalView_pop_otherView_b{
                width: 100%;
                height: calc(100% - 150px);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .modalView_pop_otherView_b_iconView{
                    width: 100px;
                    height: 100px;

                    .modalView_pop_otherView_b_iconView_img{
                        width: 100px;
                        height: 100px;
                    }
                }

                .modalView_pop_otherView_b_text1{
                    font-size: 40px;
                    color: rgba(0, 0, 0, 1);
                    font-weight: 500;
                }

                .modalView_pop_otherView_b_text2{
                    font-size: 16px;
                    color: rgba(117, 117, 117, 1);
                    margin-top:65px;
                }
            }
        }
    }
}

/* 如果使用scoped，可能需要调整选择器，例如使用深度选择器 >>> */
*[innerHTML*="<br>"] {
    display: inline-block;
    text-indent: 0;
}
*[innerHTML*="<br>"] br + * {
    display: block;
    text-indent: 2em;
}
</style>
